export default {
  header: 'Necesitamos verificar tu número de teléfono',
  remember_device: {
    label: 'Recordar este dispositivo durante {{days}} días',
  },
  buttons: {
    confirm: 'Confirmar',
  },
  toasts: {
    invalid_code: 'Código inválido. Por favor, inténtalo de nuevo.',
  },
};
